module.exports = __webpack_public_path__ + "media/images/squared-7-9cae243311106c01987d035d4e38597c.png";